import { playdataLegalPageQueryOptions } from "@data/public-page-data-query"
import * as m from "@paraglide/messages"
import PlaydataLegalBody from "@playdata/PlaydataLegalBody"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/terms")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      playdataLegalPageQueryOptions("playdataTerms", params.locale as SupportedLocale)
    ),
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_terms_meta_description({}, { locale }),
      locale,
      path: "/playdata/terms",
      title: m.playdata_terms_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: raw } = Route.useParams()
  const locale = raw as SupportedLocale
  const document = Route.useLoaderData()
  return (
    <PlaydataLegalBody
      body={document?.body ?? ""}
      heading={document?.title || m.playdata_terms_heading({}, { locale })}
    />
  )
}
